import { Zap, Crown, Lock, Check } from "lucide-react";

const OPTIONS = [
  { id: "standard", icon: Zap, title: "Standard", hint: "Fast, lower cost. Talking-presenter ads up to 15s.", accent: "emerald" },
  { id: "premium", icon: Crown, title: "Premium", hint: "Our highest quality. All ad styles, up to 30s.", accent: "amber" },
];

const STYLES = {
  emerald: { card: "bg-emerald-500/10 border-emerald-500", text: "text-emerald-400" },
  amber: { card: "bg-amber-500/10 border-amber-500", text: "text-amber-400" },
};

const creditLabel = (n) => `${n} credit${n === 1 ? "" : "s"}`;

export function UgcQualityPicker({ options, value, onChange, onUpgrade }) {
  if (!options) return null;
  return (
    <div data-testid="ugc-quality-picker">
      <h2 className="text-lg font-semibold text-white mb-3">Video Quality</h2>
      <div className="grid grid-cols-2 gap-3">
        {OPTIONS.map(({ id, icon: Icon, title, hint, accent }) => {
          const allowed = options[id];
          const selected = value === id;
          const style = STYLES[accent];
          return (
            <button
              key={id}
              type="button"
              data-testid={`ugc-quality-${id}`}
              onClick={() => (allowed ? onChange(id) : onUpgrade())}
              className={`text-left p-4 rounded-xl border-2 transition-colors ${
                selected ? style.card : "bg-white/5 border-white/10 hover:border-white/30"
              }`}
            >
              <div className="flex items-center justify-between">
                <span className="flex items-center gap-2">
                  <Icon className={`w-4 h-4 ${selected ? style.text : "text-white/60"}`} />
                  <span className={`font-semibold ${selected ? style.text : "text-white"}`}>{title}</span>
                </span>
                {selected ? <Check className={`w-4 h-4 ${style.text}`} /> : !allowed && <Lock className="w-4 h-4 text-white/40" />}
              </div>
              <p className="text-white/50 text-xs mt-1">{hint}</p>
              <p data-testid={`ugc-quality-${id}-cost`} className="text-[11px] mt-2 text-white/70">
                {allowed ? `${creditLabel(options.credits?.[id])} per ad${options.credits?.[`${id}_30s`] ? ` (${options.credits[`${id}_30s`]} for 30s)` : ""}` : "Upgrade to unlock"}
              </p>
            </button>
          );
        })}
      </div>
    </div>
  );
}
